export const CONFIG = {
  calendlyLink: 'https://calendly.com/olja-occonsulting/30min',
  loginLink: 'https://dev.emerik.fit',
  company: {
    name: 'Emerik',
    tagline: 'Transform Your Training Business',
    description: 'Emerik is a comprehensive CRM platform designed for personal trainers to manage clients, track progress, and optimize their business operations.',
    logo: {
      src: '/emerik-logo.png',
      alt: 'Emerik Logo',
      width: 160,
      height: 57
    }
  },
  contact: {
    email: 'marketing@emerik.fit',
    phone: '+387 (63) 062-739',
  },
} as const;

export type Config = typeof CONFIG;
